import { render, staticRenderFns } from "./ProjectTeamCard.vue?vue&type=template&id=7647e1b4&scoped=true"
import script from "./ProjectTeamCard.vue?vue&type=script&lang=js"
export * from "./ProjectTeamCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectTeamCard.vue?vue&type=style&index=0&id=7647e1b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7647e1b4",
  null
  
)

export default component.exports